import * as pdfjs from 'pdfjs-dist';

pdfjs.GlobalWorkerOptions.workerSrc =
  'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

export async function extractPdfContent(pdfFilePath) {
  try {
    const loadingTask = pdfjs.getDocument(pdfFilePath);
    const pdfDocument = await loadingTask.promise;
    const numPages = pdfDocument.numPages;
    let pdfContent = '';

    for (let pageNumber = 1; pageNumber <= numPages; pageNumber++) {
      const page = await pdfDocument.getPage(pageNumber);
      const textContent = await page.getTextContent();
      const pageText = textContent.items
        .map((item) => (item as any).str)
        .join(' ');
      pdfContent += pageText;
      const MAX_CHARACTERS =
        Number(process.env.NEXT_PUBLIC_MAX_CHARACTER_COUNT) || 5000;
      if (pdfContent.length >= MAX_CHARACTERS) {
        break;
      }
    }

    return pdfContent;
  } catch (error) {
    console.error('Error extracting PDF content:', error);
    throw error;
  }
}
